import { Injectable } from '@angular/core';
import { CasualTournamentDetails } from '@fantaz/shared/data-access/models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as CasualTournamentDetailsActions from './casual-tournament-details.actions';
import * as CasualTournamentDetailsSelectors from './casual-tournament-details.selectors';

@Injectable()
export class CasualTournamentDetailsFacade {
  /**
   * Loading status
   */
  loaded$: Observable<boolean> = this.store.pipe(
    select(CasualTournamentDetailsSelectors.getCasualTournamentDetailsLoaded),
  );

  /**
   * Loading error message
   */
  error$: Observable<any> = this.store.pipe(
    select(CasualTournamentDetailsSelectors.getCasualTournamentDetailsError),
  );

  /**
   * Tournament details data
   */
  details$: Observable<CasualTournamentDetails | null> = this.store.pipe(
    select(CasualTournamentDetailsSelectors.getCasualTournamentDetails),
  );

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  fetchTournamentDetails(data: { url: string }) {
    this.store.dispatch(
      CasualTournamentDetailsActions.loadCasualTournamentDetails({
        url: data.url,
      }),
    );
  }
}
